/*
  Ecom Project - ficha de producto (15-oct-2026). Ver snippets/ep-ficha.liquid.

  1. Barra fija "Anadir al carrito" en movil: aparece cuando el boton
     principal no esta en pantalla y, al tocarla, pulsa ESE boton. Copia la
     variante y el precio que muestra la ficha.
  2. "Leer mas" para la descripcion recortada en movil.
  3. Entrega estimada con fechas (dias habiles, hora de Lima).

  El tema re-pinta la columna de la ficha (morph) al cambiar de variante:
  por eso todo se busca de nuevo en cada actualizacion y nada guarda
  referencias fijas a nodos de la ficha.
*/
(function () {
  'use strict';
  if (window.__epFicha) return;
  window.__epFicha = true;

  var movil = window.matchMedia('(max-width: 749px)');

  function columna() {
    return document.querySelector('.product-information .buy-buttons-block') ? document.querySelector('.product-information') : null;
  }

  function botonPrincipal() {
    var col = columna();
    return col ? col.querySelector('.buy-buttons-block .add-to-cart-button, .buy-buttons-block button[name="add"]') : null;
  }

  /* ---------------------------------------------------------------- */
  /* 2. Leer mas                                                      */
  /* ---------------------------------------------------------------- */
  function leerMas() {
    var col = columna();
    if (!col || !movil.matches) return;
    col.querySelectorAll('.group-block-content > rte-formatter.text-block').forEach(function (el) {
      if (el.querySelector('.ep-desc__mas')) return;
      var sig = el.nextElementSibling;
      var antesDelBoton = false;
      while (sig) {
        if (sig.classList && sig.classList.contains('buy-buttons-block')) {
          antesDelBoton = true;
          break;
        }
        sig = sig.nextElementSibling;
      }
      if (!antesDelBoton || el.scrollHeight <= el.clientHeight + 4) return;

      el.classList.add('ep-desc--recortada');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ep-desc__mas';
      b.textContent = 'Leer más';
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function () {
        var abierta = el.classList.toggle('ep-desc--abierta');
        b.textContent = abierta ? 'Leer menos' : 'Leer más';
        b.setAttribute('aria-expanded', abierta ? 'true' : 'false');
        if (!abierta) el.scrollIntoView({ block: 'nearest' });
      });
      el.appendChild(b);
    });
  }

  /* ---------------------------------------------------------------- */
  /* 3. Entrega estimada (snippets/ep-confianza-compra.liquid)        */
  /*    Dias habiles en hora de Lima. Si se pide antes de la hora de  */
  /*    corte de un dia habil, cuenta desde hoy; si no, desde el      */
  /*    siguiente dia habil. Sin JS queda el texto "1 a 2 dias..."    */
  /* ---------------------------------------------------------------- */
  function entrega() {
    document.querySelectorAll('[data-ep-entrega]').forEach(function (el) {
      if (el.getAttribute('data-ep-listo') === '1') return;
      try {
        var p = {};
        new Intl.DateTimeFormat('en-CA', {
          timeZone: 'America/Lima',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          hourCycle: 'h23'
        })
          .formatToParts(new Date())
          .forEach(function (x) {
            p[x.type] = x.value;
          });
        var hoy = new Date(Date.UTC(+p.year, +p.month - 1, +p.day, 12));
        var hora = +p.hour;
        var corte = parseInt(el.dataset.corte, 10) || 16;
        var sabado = el.dataset.sabado === 'true';
        var feriados = (el.dataset.feriados || '').match(/\d{4}-\d{2}-\d{2}/g) || [];

        var iso = function (f) {
          return f.toISOString().slice(0, 10);
        };
        var habil = function (f) {
          var d = f.getUTCDay();
          return d !== 0 && (d !== 6 || sabado) && feriados.indexOf(iso(f)) === -1;
        };
        var siguiente = function (f) {
          var n = new Date(f.getTime());
          do {
            n.setUTCDate(n.getUTCDate() + 1);
          } while (!habil(n));
          return n;
        };
        var sumar = function (f, dias) {
          var n = f;
          for (var i = 0; i < dias; i++) n = siguiente(n);
          return n;
        };

        var desdeHoy = habil(hoy) && hora < corte;
        var inicio = desdeHoy ? hoy : siguiente(hoy);
        // Plazo: "24-48 h habiles despues de confirmar el pago" = 1 a 2 dias habiles despues del dia de inicio.
        var dia = function (f) {
          var q = {};
          new Intl.DateTimeFormat('es-PE', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' })
            .formatToParts(f)
            .forEach(function (x) {
              q[x.type] = x.value.replace('.', '');
            });
          return { semana: q.weekday, dia: q.day, mes: q.month };
        };
        var rango = function (txt) {
          var r = (txt || '').split('-');
          // 0 = el mismo dia de inicio (rango editable desde 0 en Ajustes del tema)
          var desde = parseInt(r[0], 10);
          var hasta = parseInt(r[1], 10);
          if (isNaN(desde)) desde = 1;
          if (isNaN(hasta) || hasta < desde) hasta = desde;
          var a = dia(sumar(inicio, desde));
          var b = dia(sumar(inicio, hasta));
          if (a.dia === b.dia && a.mes === b.mes) return a.semana + ' ' + a.dia + ' ' + a.mes;
          return a.semana + ' ' + a.dia + (a.mes === b.mes ? '' : ' ' + a.mes) + ' – ' + b.semana + ' ' + b.dia + ' ' + b.mes;
        };

        var hCorte = corte === 12 ? '12:00 p. m.' : corte > 12 ? corte - 12 + ':00 p. m.' : corte + ':00 a. m.';
        // Textos editables en Ajustes del tema > Ficha de producto: compra
        var titulo = el.dataset.titulo || 'Entrega estimada:';
        var tituloHoy = (el.dataset.tituloHoy || titulo).replace('[hora]', hCorte);
        el.querySelector('[data-ep-entrega-titulo]').textContent = desdeHoy ? tituloHoy : titulo;
        var lima = el.querySelector('[data-ep-entrega-lima]');
        var provincia = el.querySelector('[data-ep-entrega-provincia]');
        if (lima) lima.textContent = rango(el.dataset.lima);
        if (provincia) provincia.textContent = rango(el.dataset.provincia);
        el.setAttribute('data-ep-listo', '1');
      } catch (e) {
        /* sin Intl o con datos raros: queda el texto en dias */
      }
    });
  }

  /* ---------------------------------------------------------------- */
  /* 1. Barra fija                                                    */
  /* ---------------------------------------------------------------- */
  var barra = document.querySelector('[data-ep-compra-fija]');
  var nombres = {};
  var textoBoton = '';
  var principalVisible = true;
  var visible = false;

  if (barra) {
    try {
      nombres = JSON.parse(document.querySelector('[data-ep-cf-variantes]').textContent);
    } catch (e) {
      nombres = {};
    }
    textoBoton = barra.querySelector('[data-ep-cf-agregar]').textContent.trim();
  }

  // Los botones de Doctor Lab y de puntos (Gamiphy) estan fijos abajo:
  // suben mientras la barra esta visible para no taparse entre si.
  function moverLanzadores(alto) {
    document.documentElement.style.setProperty('--ep-cf-alto', alto + 'px');
    var raiz = document.getElementById('gamiphy-root');
    if (!raiz) return;
    raiz.querySelectorAll('div').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed') return;
      var r = el.getBoundingClientRect();
      if (r.height < 30 || r.height > 140 || r.width > 160 || window.innerHeight - r.bottom > 140) return;
      el.style.translate = alto ? '0 -' + alto + 'px' : '';
    });
  }

  // Gamiphy pinta (y a veces vuelve a pintar) su boton despues: mientras la
  // barra esta visible se reacomoda cada vez que cambia, y otra vez al
  // terminar la animacion de entrada de la barra (20-oct-2026).
  var vigilaLanzadores = null;
  var reintentos = [];
  function acomodarLanzadores() {
    if (visible) moverLanzadores(barra.offsetHeight);
  }

  function vigilarLanzadores(si) {
    reintentos.forEach(clearTimeout);
    reintentos = [];
    if (vigilaLanzadores) {
      vigilaLanzadores.disconnect();
      vigilaLanzadores = null;
    }
    if (!si) return;
    reintentos = [300, 1200].map(function (ms) {
      return setTimeout(acomodarLanzadores, ms);
    });
    if (!('MutationObserver' in window)) return;
    // Si Gamiphy aun no cargo, se espera a que agregue #gamiphy-root al body.
    var raiz = document.getElementById('gamiphy-root');
    var pendiente = false;
    vigilaLanzadores = new MutationObserver(function () {
      if (!raiz && (raiz = document.getElementById('gamiphy-root'))) {
        // ya llego: desde ahora se mira solo dentro de Gamiphy (pinta sus botones despues)
        vigilaLanzadores.disconnect();
        vigilaLanzadores.observe(raiz, { childList: true, subtree: true });
      }
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () {
        pendiente = false;
        acomodarLanzadores();
      });
    });
    vigilaLanzadores.observe(raiz || document.body, raiz ? { childList: true, subtree: true } : { childList: true });
  }

  function mostrar(si) {
    if (!barra || si === visible) return;
    visible = si;
    barra.classList.toggle('is-visible', si);
    barra.setAttribute('aria-hidden', si ? 'false' : 'true');
    barra.querySelectorAll('button').forEach(function (b) {
      b.tabIndex = si ? 0 : -1;
    });
    document.documentElement.classList.toggle('ep-cf-visible', si);
    moverLanzadores(si ? barra.offsetHeight : 0);
    vigilarLanzadores(si);
  }

  function evaluar() {
    mostrar(movil.matches && !principalVisible && window.scrollY > 150);
  }

  function sincronizar() {
    if (!barra) return;
    var col = columna();
    if (!col) return;
    var id = col.querySelector('.buy-buttons-block input[name="id"]');
    var etiqueta = barra.querySelector('[data-ep-cf-variante]');
    if (id && nombres[id.value] && nombres[id.value] !== 'Default Title') etiqueta.textContent = nombres[id.value];

    var precio = col.querySelector('product-price .price');
    if (precio && precio.textContent.trim()) barra.querySelector('[data-ep-cf-precio]').textContent = precio.textContent.trim();

    var b = botonPrincipal();
    var agregar = barra.querySelector('[data-ep-cf-agregar]');
    if (b) {
      agregar.disabled = b.disabled;
      agregar.textContent = b.disabled ? 'Agotado' : textoBoton;
    }
    observarBoton();
  }

  var observador = null;
  var observado = null;
  function observarBoton() {
    var b = botonPrincipal();
    if (!b || b === observado || !('IntersectionObserver' in window)) return;
    if (observador) observador.disconnect();
    observado = b;
    // Margen superior: el encabezado fijo (~70 px) tapa el boton antes de
    // que salga de la pantalla.
    observador = new IntersectionObserver(
      function (entradas) {
        principalVisible = entradas[entradas.length - 1].isIntersecting;
        evaluar();
      },
      { rootMargin: '-90px 0px 0px 0px' }
    );
    observador.observe(b);
  }

  if (barra) {
    barra.querySelector('[data-ep-cf-agregar]').addEventListener('click', function () {
      var b = botonPrincipal();
      if (b && !b.disabled) b.click();
    });
    barra.querySelector('[data-ep-cf-opciones]').addEventListener('click', function () {
      var col = columna();
      if (!col) return;
      var destino = [col.querySelector('.rio-options'), col.querySelector('variant-picker'), col.querySelector('.buy-buttons-block')].filter(function (el) {
        return el && el.offsetHeight > 0;
      })[0];
      if (destino) destino.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    var pendiente = false;
    window.addEventListener(
      'scroll',
      function () {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(function () {
          pendiente = false;
          evaluar();
        });
      },
      { passive: true }
    );
    if (movil.addEventListener) movil.addEventListener('change', evaluar);
  }

  /* ---------------------------------------------------------------- */
  /* Arranque y re-pintados de la ficha                               */
  /* ---------------------------------------------------------------- */
  var temporizador = null;
  function actualizar() {
    clearTimeout(temporizador);
    temporizador = setTimeout(function () {
      sincronizar();
      leerMas();
      entrega();
    }, 80);
  }

  document.addEventListener('variant:update', actualizar);
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.product-information')) actualizar();
  });

  function iniciar() {
    sincronizar();
    leerMas();
    entrega();
    var col = columna();
    if (col && 'MutationObserver' in window) {
      new MutationObserver(actualizar).observe(col, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
